import {Routes} from "./Routes";
import {makeStyles} from "@mui/styles";
import {Theme} from "@mui/material";

export const pageVariants = {
    initial: {
        opacity: 0,
        marginLeft: "100%",
    },
    in: {
        opacity: 1,
        marginLeft: 0,
    },
    out: {
        opacity: 0,
        marginLeft: "-100%",
    }
};

export const IntegrationMenu = [
    {
        title: "Authentication",
        link: Routes.IntegrationEditorAuth,
    },
    {
        title: "Triggers",
        link: Routes.IntegrationEditorTrigger,
    },
    {
        title: "Actions",
        link: Routes.IntegrationEditorAction,
    },
];

export const pageTransition = {
    type: "tween",
    ease: "anticipate",
    duration: 0.5
};

export const IntegrationAuthTypes: any = {
    API_KEY: "API KEY",
    SESSION_AUTH: "SESSION AUTH",
    BASIC_AUTH: "BASIC AUTH",
    OAUTH2: "OAuth v2",
};

export const AuthTypesInfo: any = {
    API_KEY: {
        title: "WHAT_IS_API_KEY",
        description: "WHAT_IS_API_KEY_ANSWER"
    },
    SESSION_AUTH: {
        title: "WHAT_IS_SESSION_AUTH",
        description: "WHAT_IS_SESSION_AUTH_ANSWER"
    },
    BASIC_AUTH: {
        title: "WHAT_IS_BASIC_AUTH",
        description: "WHAT_IS_BASIC_AUTH_ANSWER"
    },
    OAUTH2: {
        title: "WHAT_IS_OAUTH2",
        description: "WHAT_IS_OAUTH2_ANSWER"
    },
};

export const ApiRequestMethods: any = {
    Get: "GET",
    Post: "POST",
    Put: "PUT",
    Patch: "PATCH",
    Head: "HEAD",
    Delete: "DELETE",
    Options: "OPTIONS",
    Trace: "TRACE",
};

export interface ApiEndPointFieldsProps {
    readonly code: string
    readonly value: string
    readonly saved: boolean
    readonly id: number
}

export interface SelectOptions {
    readonly label: string,
    readonly value: string
}


export const IntegrationFormStepsStyle = makeStyles((theme: Theme) => ({
    root: {
        "& .MuiStepConnector-root": {
            display: "none"
        }
    },
    disabledStep: {
        opacity: 0.6,
        pointerEvents: "none"
    },
    stepRoot: {
        background: "#fff",
        borderRadius: 10,
        boxShadow: theme.shadows[1],
        marginBottom: 20,
        "&.active": {
            "& .MuiStepContent-root": {
                padding: "0 60px 20px"
            }
        },
        "& .MuiStepLabel-iconContainer": {
            display: "none"
        },
        "& .MuiStepLabel-label": {
            display: "flex",
            alignItems: "center"
        },
        "& .MuiStepLabel-root": {
            padding: "25px 70px",
            cursor: "pointer !important" as any
        },
        "& .MuiStepContent-root": {
            border: "none",
            transition: "0.3s"
        }
    },
    content: {
        border: "1px solid #d9d9d9",
        borderRadius: 8,
        padding: 15
    },
    stepOrder: {
        padding: "4px 16px",
        borderRadius: 25,
        background: "#E8E8E8",
        marginRight: 16,
        color: "#000",
        fontWeight: 700,
        fontSize: 14,
    },
    labelTitle: {
        fontSize: 18,
        fontWeight: 700,
        color: "#000"
    }
}));



export const defaultApiEndpointCode = `const options = {
  url: '',
  method: 'GET',
  headers: {

  },
  params: {

  }
}

return k.request(options)
  .then((response) => {
    const results = response.json;

    // You can do any parsing you need for results here before returning them

    return results;
  });`;